<template>
  <!-- 미리보기 재생 — 리액션 에디터 nle__preview 스타일 (심플 원형 플레이 아이콘, muted → hover 보라). -->
  <v-icon
    class="play-button"
    :class="{ 'play-button--light': !isDark }"
    size="20"
    title="미리보기"
    @click="$emit('click', $event)"
    >mdi-play-circle-outline</v-icon
  >
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";

export default {
  name: "PlayButton",
  mixins: [Themeable], // isDark(앱 테마/컨텍스트 상속) → 라이트/다크 hover 대비 분기
};
</script>

<style scoped>
.play-button {
  color: #7d7d90 !important;
  transition: color 0.12s ease;
}
/* 다크: 연보라 hover */
.play-button:hover {
  color: #b79cff !important;
}
/* 라이트: 흰 배경 대비 위해 더 진한 보라 hover */
.play-button--light:hover {
  color: #7c4dff !important;
}
</style>
